import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useLocation, useParams } from 'react-router-dom';

import { Tags } from '../tag/Tags';
import { PageViewerToolBarContent } from './PageViewerToolBarContent';

export function ToolBar() {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 5,
		//backgroundColor: 'yellow',
	};
	let location = useLocation();
	const { pageId } = useParams();
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

  const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
	  console.log('is this closing happening?');
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

	return (
		<Box position="fixed" sx={sx}>

				<Typography>Ok</Typography>
				<Typography>Spaces</Typography>
				<Typography>Pages</Typography>
				<Typography>And others</Typography>
				<Typography>{location.pathname}</Typography>
				<Typography>{pageId}</Typography>
			<Box sx={sxleft}>
			</Box>
			<Box sx={sxright}>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
					onClick={handleClickOpen('paper')}
				>
					Add Page
				</Button>
			</Box>
			<PageViewerToolBarContent />
		</Box>
	)
}
